import React, { memo } from 'react';
import { NestableNavigationContent, Section } from '@atlaskit/side-navigation';
import { expVal } from '@atlassian/jira-feature-experiments';
import { useIntl } from '@atlassian/jira-intl';
import { IssuesContextualAnalyticsData } from '@atlassian/jira-navigation-apps-sidebar-common/src/ui/contextual-analytics-data/index.tsx';
import { Issues } from '@atlassian/jira-navigation-apps-sidebar-common/src/ui/issues/main.tsx';
import type { Project } from '../../../../../common/types/index.tsx';
import useAutoExpandSidebar from '../../../../../controllers/auto-expand-sidebar/index.tsx';
import messages from './messages.tsx';

const EMPTY_STACK: string[] = [];

type Props = {
	project: Project;
};

const IssuesMenu = ({ project }: Props) => {
	useAutoExpandSidebar();
	const { formatMessage } = useIntl();

	return (
		<NestableNavigationContent initialStack={EMPTY_STACK}>
			<Section>
				<IssuesContextualAnalyticsData navigatorScope="project">
					<Issues
						projectKey={project.key}
						pinUrl={`/jira/core/projects/${project.key}/issues/?filter=`}
						titleHeaderText={formatMessage(
							expVal('issue-terminology-refresh-m2-replace', 'isEnabled', false)
								? messages.issuesIssueTermRefresh
								: messages.issues,
						)}
					/>
				</IssuesContextualAnalyticsData>
			</Section>
		</NestableNavigationContent>
	);
};

export default memo<Props>(IssuesMenu);
